import styled from 'styled-components'
import { QualityClass } from './QualityBadge.types'

export const Badge = styled.div<{ $class: QualityClass }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;

  ${({ $class }) => {
    const colors = {
      A: { bg: '#10b98120', color: '#10b981' },
      B: { bg: '#3b82f620', color: '#3b82f6' },
      C: { bg: '#f59e0b20', color: '#f59e0b' },
      D: { bg: '#f9731620', color: '#f97316' },
      E: { bg: '#ef444420', color: '#ef4444' },
      F: { bg: '#dc262620', color: '#dc2626' },
    }
    const config = colors[$class] || colors.F
    return `
      background: ${config.bg};
      color: ${config.color};
    `
  }}
`
